import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CodaltComponent } from '../../codalt.component';
import { CustomerProject } from '../../customer-project.interface';
import { LocalStorage } from '../../local-storage.class';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerProjectService } from '../../services/customer-project/customer-project.service';

@Component({
    selector: 'app-add-customer-project-modal',
    templateUrl: './add-customer-project-modal.component.html',
    styleUrls: ['./add-customer-project-modal.component.scss'],
    standalone: false,
})
export class AddCustomerProjectModalComponent extends CodaltComponent implements OnInit {
    customerProject: CustomerProject;

    customerProjects: {
        id: number;
        name: string;
        customer_id: number;
        customer_name: string;
    }[];

    constructor(
        public dialogRef: MatDialogRef<AddCustomerProjectModalComponent>,
        private confirmDialogService: ConfirmDialogService,
        private customerProjectService: CustomerProjectService
    ) {
        super();
    }

    ngOnInit() {
        this.customerProjectService.getConsumerProjects().subscribe(res => {
            const projectIds = LocalStorage.getUser().customer_projects.map(p => p.id);
            this.customerProjects = res.data.filter(p => projectIds.indexOf(p.id) === -1);
        });
    }

    addCustomerProject() {
        this.customerProjectService.follow(this.customerProject.id).subscribe(
            result => {
                if (result.success) {
                    this.dialogRef.close();
                } else {
                    this.failed();
                }
            },
            err => {
                console.log(err);
                this.failed();
            }
        );
    }

    failed() {
        this.confirmDialogService
            .confirm('Project toevoegen mislukt', 'Het is niet gelukt om dit project toe te voegen.', 'Sluiten')
            .then(() => this.dialogRef.close());
    }
}
